import React from 'react';
import { useTranslation } from 'react-i18next';
import Btn from '../Btn/Btn';
import './FrontPageHeader.css';

type Props = {
    onLogout: () => void;
    activeMainTab: MainTab;
    onMainTabChange: (tab: MainTab) => void;
};

export type MainTab = 'questionnaires' | 'therapy-material' | 'nachsorge' | 'profile';

const FrontPageHeader = ({ onLogout, activeMainTab, onMainTabChange }: Props): JSX.Element => {
    const { t, i18n } = useTranslation();

    const toggleLanguage = (): void => {
        const newLanguage = i18n.language === 'en-US' ? 'de-DE' : 'en-US';
        i18n.changeLanguage(newLanguage);
        localStorage.setItem('editor_language', newLanguage);
    };

    const getCurrentFlag = (): string => {
        return i18n.language === 'en-US' ? '🇬🇧' : '🇩🇪';
    };

    return (
        <header>
            <div className="lang-wrapper">
                <button
                    type="button"
                    className="language-flag-button"
                    onClick={toggleLanguage}
                    aria-label={t('Change language')}
                    title={i18n.language === 'en-US' ? t('Change to German') : t('Change to English')}
                >
                    {getCurrentFlag()}
                </button>
            </div>
            <div className="form-title">
                <div className="frontpage-header__title-wrapper">
                    <h1>{t('Koala Questionnaire Builder')}</h1>
                    <div className="frontpage-header__tabs" role="tablist" aria-label={t('Main section navigation')}>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeMainTab === 'questionnaires'}
                            className={`frontpage-header__tab ${
                                activeMainTab === 'questionnaires' ? 'frontpage-header__tab--active' : ''
                            }`}
                            onClick={() => onMainTabChange('questionnaires')}
                        >
                            {t('Questionnaires')}
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeMainTab === 'therapy-material'}
                            className={`frontpage-header__tab ${
                                activeMainTab === 'therapy-material' ? 'frontpage-header__tab--active' : ''
                            }`}
                            onClick={() => onMainTabChange('therapy-material')}
                        >
                            {t('Therapy Material')}
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeMainTab === 'nachsorge'}
                            className={`frontpage-header__tab ${
                                activeMainTab === 'nachsorge' ? 'frontpage-header__tab--active' : ''
                            }`}
                            onClick={() => onMainTabChange('nachsorge')}
                        >
                            {t('Aftercare')}
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeMainTab === 'profile'}
                            className={`frontpage-header__tab ${
                                activeMainTab === 'profile' ? 'frontpage-header__tab--active' : ''
                            }`}
                            onClick={() => onMainTabChange('profile')}
                        >
                            {t('Profile')}
                        </button>
                    </div>
                </div>
            </div>
            <div className="header-actions">
                <Btn title={t('Logout')} onClick={onLogout} />
            </div>
        </header>
    );
};

export default FrontPageHeader;
